export const LICENSE_STATUS = Object.freeze({
  ACTIVE: 'active',
  EXPIRING: 'expiring',
  GRACE: 'grace',
  EXPIRED: 'expired',
  SUSPENDED: 'suspended',
});

export const LICENSE_STATUS_LIST = Object.values(LICENSE_STATUS);

export const LICENSE_STATUS_LABELS = Object.freeze({
  active: 'Active',
  expiring: 'Expiring soon',
  grace: 'In grace period',
  expired: 'Expired',
  suspended: 'Suspended',
});

export const FEATURES = Object.freeze([
  { key: 'inventory', label: 'Inventory & recipes' },
  { key: 'crm', label: 'CRM & loyalty' },
  // On unless switched off: clients from before this switch existed keep their kitchen.
  {
    key: 'kot',
    label: 'Kitchen orders (KOT)',
    default: true,
    hint: 'KOT button and kitchen tickets. Owners can still switch it off for an outlet without a kitchen.',
  },
  { key: 'kds', label: 'Kitchen display (KDS)', requires: 'kot', hint: 'Needs kitchen orders (KOT).' },
  { key: 'selfOrder', label: 'Self-order kiosk mode' },
  { key: 'multiOutlet', label: 'Multi-outlet' },
  { key: 'mallApi', label: 'Mall sales API' },
  // Reserved for the next update (constants/upcoming.js): shown as "coming soon", always off.
  { key: 'sms', label: 'SMS', comingSoon: true },
  { key: 'whatsappApi', label: 'WhatsApp Cloud API', comingSoon: true },
  { key: 'paymentGateway', label: 'Payment gateway', comingSoon: true },
]);

export const FEATURE_KEYS = Object.freeze(FEATURES.map((f) => f.key));
/** What a feature is when a licence doesn't say (saved before the feature existed). */
export const FEATURE_DEFAULTS = Object.freeze(Object.fromEntries(FEATURES.map((f) => [f.key, f.default ?? false])));

export const LIMITS = Object.freeze([
  { key: 'maxOutlets', label: 'Outlets', usageKey: 'outlets' },
  { key: 'maxDevices', label: 'Devices', usageKey: 'devices' },
  { key: 'maxUsers', label: 'Users', usageKey: 'users' },
]);

export const LIMIT_KEYS = Object.freeze(LIMITS.map((l) => l.key));

export const LICENSE_EVENT_TYPES = Object.freeze([
  'created',
  'extended',
  'renewed',
  'plan_changed',
  'limits_changed',
  'features_changed',
  'grace_changed',
  'suspended',
  'reactivated',
  'status_changed',
]);

export const LICENSE_EVENT_LABELS = Object.freeze({
  created: 'License created',
  extended: 'Expiry extended',
  renewed: 'Renewed',
  plan_changed: 'Plan changed',
  limits_changed: 'Limits changed',
  features_changed: 'Features changed',
  grace_changed: 'Grace period changed',
  suspended: 'Suspended',
  reactivated: 'Reactivated',
  status_changed: 'Status changed',
});

/** Access levels checked by the server's licenseGuard. */
export const ACCESS_LEVELS = Object.freeze({
  LOGIN: 'login',
  READ: 'read',
  WRITE: 'write',
  BILLING: 'billing',
});

export const DEFAULT_LICENSE_SETTINGS = Object.freeze({
  expiryBannerDays: 15,
  defaultGraceDays: 7,
  offlineBillingHours: 72,
  reminderDays: [15, 7, 3, 1, 0],
});

export const LICENSE_PAYMENT_METHODS = Object.freeze(['upi', 'bank_transfer', 'cash', 'card', 'cheque', 'other']);
